<template>
  <div ref="content">
    <div class="nonPrint mx-4" style="margin-top: 20px;">
      <v-toolbar dark class="toolbarcreatedadmin nonPrint" style="margin-top: 20px;">
        <v-btn icon @click="routeinfo()">
          <v-icon>fas fa-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>รายละเอียดข้อมูล admin</v-toolbar-title>
      </v-toolbar>
    </div>

    <div class="nonPrint" style="margin-top: 20px;">
      <table class="tableInfor" v-if="data_generate">
        <tr>
          <td class="div_infor_header">Generate ID:</td>
          <td class="div_infor" colspan="3">{{ generate_id }}</td>
        </tr>
        <tr>
          <td class="div_infor_header">หน่วยงานเจ้าของ: </td>
          <td class="div_infor">{{ data_generate && data_generate[0] ? data_generate[0].company_name : '-' }}</td>
          <td class="div_infor_header">ประเภทหน่วยงาน:</td>
          <td class="div_infor">{{ data_generate && data_generate[0] ? checkTypeCompany(data_generate[0].company_type) : '-' }}</td>
        </tr>
        <tr>
          <td class="div_infor_header">ผู้สร้าง:</td>
          <td class="div_infor">{{ data_generate && data_generate[0] ? data_generate[0].who_create : '-' }}</td>
          <td class="div_infor_header">วัน เวลา ที่สร้าง:</td>
          <td class="div_infor">{{ data_generate && data_generate[0] ? momentdatethai(data_generate[0].create_at) : '-' }} {{
            momenttimethai(data_generate.create_at)}}น.</td>
        </tr>
      </table>
      <table class="tableInfor" style="margin-top: 15px;" v-if="data_generate">
        <tr>
          <td class="div_infor_headerDetail">จำนวน:</td>
          <td class="div_infor">{{ (data_generate.length) ? (data_generate.length) : '-' }}</td>
          <td class="div_infor_headerDetail">ประเภทผู้ใช้งาน:</td>
          <td class="div_infor">{{ data_generate && data_generate[0] ? data_generate[0].role : '-' }}</td>
        </tr>
      </table>
      <div class="nonPrint positionPrint">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2" outlined fab small color="#a80f00" @click="print()" v-on="on">
              <img :src="BASE_URL + 'static/iconButton/printing.png'" alt="" width="25px">
            </v-btn>
          </template>
          <span class="nonPrint">Print</span>
        </v-tooltip>
      </div>
    </div>

    <div id="PDF" style="margin-right: 30px; margin-left: 30px; overflow: auto;">
      <div class="pageBreak">
        <table class="customers Kanit" style="margin-top: 30px;margin-bottom: 30px;">
          <tr>
            <th>username</th>
            <th>password</th>
            <th>ชื่อ-นามสกุล</th>
            <th>หมายเลขโทรศัพท์</th>
            <th>อีเมล</th>
            <th>ลงทะเบียนอาสาสมัคร</th>
          </tr>
          <tr v-for="item in data_generate">
            <td class="text-left">{{ (item.username) ? item.username : '-' }}</td>
            <!-- {{item.is_generate}} -->
            <td class="text-left" v-if="item.is_generate">{{ passwordCheck(item.password, item.is_generate) }}</td>
            <td class="text-left" v-else-if="item.password == null">-</td>
            <td class="text-left" v-else><v-chip small> เปลี่ยนแปลงแล้ว </v-chip></td>
            <td class="text-left">{{ name(item.first_name, item.last_name) }}</td>
            <td class="text-left">{{ (item.phone) ? item.phone : '-' }}</td>
            <td class="text-left">{{ (item.email) ? item.email : '-' }}</td>
            <td class="text-left">{{ volunteer(item.is_runner, item.is_cpr) }}</td>
            <td style="border: none !important;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-2" outlined fab small color="#a80f00" @click="changeRole(item)" v-on="on" style="width: 25px !important; height: 25px !important;">
                    <img :src="BASE_URL + 'static/iconButton/role_change_3.svg'" alt="" width="15px">
                  </v-btn>
                </template>
                <span class="nonPrint">เปลี่ยนประเภทผู้ใช้งาน</span>
              </v-tooltip>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <ChangeRole :dialogedit_role="dialogedit_role" :data_user="data_user" @closeedit_role="closeedit_role"></ChangeRole>
  </div>
</template>

<script>
// var _ = require('lodash')
import ChangeRole from '@/components/edit/edit_role_modal'
var moment = require('moment')
import { Decode, Momenttime } from '@/services'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_BACKEND: process.env.API_BACKEND,
      generate_id: '',
      data_generate: {},
      dialogedit_role: false,
      data_user: {}
    }
  },
  created () {
    this.generate_id = this.$route.query.id
    this.getListAdmin()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  components: {
    ChangeRole
  },
  methods: {
    changeRole (item) {
      this.data_user = item
      this.dialogedit_role = true
    },
    closeedit_role (value) {
      this.dialogedit_role = false

      if (value !== false) {
        this.getListAdmin(value)
      }
    },
    routeinfo () {
      // this.$router.push('information/qrcode')
      this.$router.back()
    },
    passwordCheck (password, is_generate) {
      if (is_generate) {
        return password
      } else {
        return 'เปลี่ยนแปลงแล้ว'
      }
    },
    volunteer (runner, cpr) {
      if (cpr && runner) {
        return 'Hero CPR, Run for AED'
      } else if (cpr) {
        return 'Hero CPR'
      } else if (runner) {
        return 'Run for AED'
      } else {
        return '-'
      }
    },
    name (first,last) {
      if (first == null && last == null) {
        return '-'
      } else {
        return first + ' ' + last
      }

    },
    checkTypeCompany (data) {
      if(data === 'owner') {
        return 'หน่วยงานในเครือสภากาชาด'
      } else if(data === 'partner') {
        return 'หน่วยงานร่วมโครงการ'
      } else if(data === 'maintenance') {
        return 'หน่วยงานบำรุงรักษาเครื่อง AED'
      } else {
        return '-'
      }

    },
    //  momentdatethai (data) {
    //   return moment(data).tz('Asia/Bangkok').lang('th').format('ll')
    // },
    // momenttimethai (data) {
    //   return (moment(data).tz('Asia/Bangkok').lang('th').format('LT'))
    // },
    momentdatethai(data) {
      return Momenttime.momentdatethai(data)
    },
    momenttimethai(data) {
      return Momenttime.momenttimethai(data)
    },
    print () {
      window.print()
    },
    getListAdmin (value) {
      var body = {
        generate_id: value ? value : this.generate_id
      }
      this.$api.getDetailUserByGenerateId(body).then((response) => {
        if (response.data.data.length != 0) {
          this.data_generate = response.data.data
          // console.log(this.data_generate)
          this.decodePassword(this.data_generate)
        } else {
          this.$router.push('/information/admin')
        }
      })
    },
    decodePassword (data_generate) {
      var listPass = _.map(data_generate, 'password')
      var body = {
        list_password: listPass
      }

      this.$api.decodePWDByList(body).then((response) => {
        var result = response.data.data
        result.forEach((item, index) => {
          // console.log(item)
          if (this.data_generate[index].is_generate) {
            this.data_generate[index].password = item
          }
        })
      }).catch((error) => {

      })
    }
  }
}
</script>
<style media="screen" scoped>
  >>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .inputinfor_address {
    height: 110px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor_dis {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: #FAF0F0 !important;
  }
  >>>.theme--dark.v-select .v-select__selections {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-label {
      color: hsl(5, 100%, 33%) !important;
  }
  >>>.theme--dark.v-icon {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: #a80e00 !important;
  }
  .toolbarcreatedadmin {
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-width: thin !important;
    border-right-color: transparent !important;
    border-style: solid !important;
    height: 64px !important;
    border-left-style: initial !important;
    border-right-style: initial !important;
    border-radius: 0px !important;
    border-bottom-color: #a80e00 !important;
    background-color: white !important;
    color: #a80e00 !important;
    border-width: thin !important;
    box-shadow: none !important;
  }
  .btngen {
    background-color: white !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
    width: 120px !important;
  }
  .btncreateuser {
    background-color: #a80f00 !important;
    color: #fafafa !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
  }
  .btncreateuser:disabled {
    background-color: #a80f0099 !important;
    color: #fafafa9c !important;
    border-color: #a80f0091 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

  .btncancle {
    background-color: #fafafa !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    width: 160px !important;
  }

  .div_infor_header {
    width: 10vw;
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 20px;
  }
  .div_infor {
    width: 20vw;
    border: solid 1px #a80d00;
    text-align: left;
    padding-left: 20px;
  }
  .div_infor_headerDetail {
    width: 10vw;
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 10px;
  }
  .tableInfor {
    justify-content: center;
    display: inline-table;
    width: 70vw;
  }
  .positionPrint {
    width: 70vw;
      margin-left: 30vw;
      text-align: right;
      padding-right: 16vw;
  }
  .customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
}

.customers td, .customers th {
  border: 1px solid #ddd;
  padding: 8px;
}


.customers th {
  background-color: #a80d00;
  color: white;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
  text-align: center !important;
  /*width: 35%;*/
}
.customers td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  text-align: left !important;
  width: 400px;
}

  @media screen {
    #PDF {
      height: 45vh !important;
      overflow: scroll;

    }
  }
  @media print {
    .nonPrint {
      display: none;
    }
    #PDF {
      height: auto;
      overflow: hidden;
      -webkit-print-color-adjust: exact; 
    }
    .pageBreak { page-break-inside:always; }
    .pageBreak * {
      page-break-after:avoid;
      page-break-before:avoid;
    }
  }
  .Kanit {
    font-family: 'Kanit', sans-serif !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/information_print/infor_groupadmin.vue